export const MERCHANT_FEE_PRINT_SCOPE_MAIN = "MAIN";
export const MERCHANT_FEE_PRINT_SCOPE_SUPPLEMENTARY = "SUPPLEMENTARY";

const GROUP_MAIN = "MAIN";
const GROUP_SUPPLEMENTARY = "SUPPLEMENTARY";
const BACKFILL_AREA_CATEGORY = "BACKFILL_BASE_AREA";
const WATERPROOF_AREA_CATEGORY = "WATERPROOF_BASE_AREA";
const WATERPROOF_AREA_ROLES = ["BASE_PIT_AREA", "SURFACE_AREA"];

const toNumber = value => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const toCents = value => Math.round(toNumber(value) * 100);

const escapeHtml = value => String(value == null ? "" : value)
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
  .replace(/'/g, "&#39;");

const formatMoney = value => (toCents(value) / 100).toFixed(2);

const formatDateTime = value => {
  if (value === null || value === undefined || value === "") return "无";
  const date = new Date(Number(value));
  if (Number.isNaN(date.getTime())) return escapeHtml(value);
  const pad = number => String(number).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const resolveUnit = item => {
  if (item && item.unit) return item.unit;
  const name = String((item && item.name) || "");
  if (name.indexOf("面积") !== -1 || name.indexOf("平方") !== -1 || name.indexOf("丙纶") !== -1) return "平方";
  if (name.indexOf("上门") !== -1 || name.indexOf("次数") !== -1) return "次";
  if (name.indexOf("个数") !== -1) return "个";
  if (name.indexOf("公里") !== -1) return "公里";
  return "项";
};

const normalizeItemName = value => String(value == null ? "" : value)
  .replace(/[0-9０-９\s\u3000]/g, "");

const isBackfillBaseArea = item => {
  if (Number(item && item.costGrouping) !== 1) return false;
  if (item && item.merchantFeeCategory === BACKFILL_AREA_CATEGORY) return true;
  const name = normalizeItemName(item && item.name);
  return name === "施工面积" || name === "回填面积" || name === "回填施工面积";
};

const isWaterproofBaseArea = item => {
  if (Number(item && item.costGrouping) === 1) return false;
  if (item && (item.merchantFeeCategory === WATERPROOF_AREA_CATEGORY ||
    WATERPROOF_AREA_ROLES.indexOf(item.waterproofAreaRole) !== -1)) {
    return true;
  }
  const name = normalizeItemName(item && item.name);
  return name.indexOf("二次上门增加施工面积") !== -1 ||
    name === "防水面积" || name === "基坑施工面积" || name === "沉箱施工面积" ||
    name === "面层施工面积" || name === "面层防水面积";
};

const resolveMerchantMergeKey = item => {
  const name = normalizeItemName(item && item.name);
  if (name.indexOf("客户原因误工费") !== -1 ||
    name.indexOf("非我公司原因造成破坏的修补费用") !== -1 ||
    name.indexOf("增项") !== -1) {
    return "ADDITION";
  }
  if (isBackfillBaseArea(item)) return "BACKFILL_AREA";
  if (isWaterproofBaseArea(item)) return "WATERPROOF_AREA";
  if (name === "超出标准丙纶施工面积" || name === "超出标准丙纶费用" || name === "丙纶工费") {
    return "EXCESS_POLYPROPYLENE";
  }
  return "";
};

const resolveMerchantDisplayName = item => {
  const name = normalizeItemName(item && item.name);
  if (name === "丙纶工费") return "超出标准丙纶费用";
  if (name.indexOf("二排") !== -1) return "施工费(二排)";
  if (name.indexOf("模具") !== -1) return "施工费(模具)";
  return item.name;
};

const MERGED_ITEM_NAMES = {
  BACKFILL_AREA: "施工费(回填宝)",
  WATERPROOF_AREA: "施工工程",
  EXCESS_POLYPROPYLENE: "超出标准丙纶费用",
  ADDITION: "增项"
};

const resolveMergedItemName = (mergeKey, stageName) =>
  mergeKey === "EXCESS_POLYPROPYLENE" && stageName === "补刷"
    ? "丙纶补刷费用"
    : MERGED_ITEM_NAMES[mergeKey];

const mergeMerchantItems = (items, stageName) => {
  const result = [];
  const mergedByKey = {};
  (items || []).forEach(item => {
    const normalizedItem = {
      ...item,
      stageName,
      name: resolveMerchantDisplayName(item)
    };
    const mergeKey = resolveMerchantMergeKey(normalizedItem);
    if (!mergeKey) {
      result.push(normalizedItem);
      return;
    }

    if (!mergedByKey[mergeKey]) {
      mergedByKey[mergeKey] = {
        ...normalizedItem,
        name: resolveMergedItemName(mergeKey, stageName),
        unit: mergeKey === "ADDITION" ? "项" : "平方",
        num: toNumber(normalizedItem.num),
        totalPrice: toCents(normalizedItem.totalPrice) / 100,
        _priceCents: toCents(normalizedItem.price),
        _samePrice: true,
        _mergeKey: mergeKey
      };
      result.push(mergedByKey[mergeKey]);
      return;
    }

    const target = mergedByKey[mergeKey];
    target.num = Math.round((target.num + toNumber(normalizedItem.num)) * 10000) / 10000;
    target.totalPrice = (toCents(target.totalPrice) + toCents(normalizedItem.totalPrice)) / 100;
    target._samePrice = target._samePrice && target._priceCents === toCents(normalizedItem.price);
  });

  return result.map(item => {
    if (!item._mergeKey) return item;
    const merged = { ...item };
    merged.remark = "";
    if (item._mergeKey === "ADDITION") {
      merged.num = 1;
      merged.price = merged.totalPrice;
    } else if (!item._samePrice && item.num !== 0) {
      merged.price = item.totalPrice / item.num;
    }
    delete merged._priceCents;
    delete merged._samePrice;
    delete merged._mergeKey;
    return merged;
  });
};

export const numberToChineseMoney = value => {
  let amount = toNumber(value);
  const negative = amount < 0;
  amount = Math.abs(amount);
  if (amount > 9999999999999.99) return "金额过大";

  const digits = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
  const integerUnits = ["", "拾", "佰", "仟"];
  const sectionUnits = ["", "万", "亿", "万亿"];
  const cents = Math.round(amount * 100);
  let integer = Math.floor(cents / 100);
  const fraction = cents % 100;

  const sectionToChinese = section => {
    let result = "";
    let unitIndex = 0;
    let zero = true;
    while (section > 0) {
      const digit = section % 10;
      if (digit === 0) {
        if (!zero) {
          result = digits[0] + result;
          zero = true;
        }
      } else {
        zero = false;
        result = digits[digit] + integerUnits[unitIndex] + result;
      }
      unitIndex += 1;
      section = Math.floor(section / 10);
    }
    return result;
  };

  let integerText = "";
  if (integer === 0) {
    integerText = digits[0];
  } else {
    let sectionIndex = 0;
    let needZero = false;
    while (integer > 0) {
      const section = integer % 10000;
      if (section === 0) {
        if (integerText) needZero = true;
      } else {
        const sectionText = sectionToChinese(section) + sectionUnits[sectionIndex];
        if (needZero || (integerText && section < 1000)) {
          integerText = digits[0] + integerText;
        }
        integerText = sectionText + integerText;
        needZero = false;
      }
      sectionIndex += 1;
      integer = Math.floor(integer / 10000);
    }
  }

  const jiao = Math.floor(fraction / 10);
  const fen = fraction % 10;
  let fractionText = "";
  if (jiao > 0) fractionText += digits[jiao] + "角";
  if (jiao === 0 && fen > 0) fractionText += digits[0];
  if (fen > 0) fractionText += digits[fen] + "分";
  if (!fractionText) fractionText = "整";
  return `${negative ? "负" : ""}${integerText}元${fractionText}`;
};

const isSupplementaryStage = stage => {
  if (!stage) return false;
  if (stage.supplementary === true || stage.supplementary === "true") return true;
  return String(stage.goodsName || "").indexOf("补刷") !== -1;
};

/**
 * 主单打印合并回填和普通防水；补刷打印只保留补刷阶段。
 */
export const groupWaterproofMerchantFees = (costData, scope = MERCHANT_FEE_PRINT_SCOPE_MAIN) => {
  const supplementary = scope === MERCHANT_FEE_PRINT_SCOPE_SUPPLEMENTARY;
  const group = {
    key: supplementary ? GROUP_SUPPLEMENTARY : GROUP_MAIN,
    name: supplementary ? "补刷" : "回填及防水",
    stageName: supplementary ? "补刷" : "回填及防水",
    items: [],
    subtotalCents: 0
  };

  (Array.isArray(costData) ? costData : []).forEach(stage => {
    if (isSupplementaryStage(stage) !== supplementary) return;
    const merchantFees = stage && Array.isArray(stage.merchantFees) ? stage.merchantFees : [];
    merchantFees.forEach(item => {
      const amountCents = toCents(item && item.totalPrice);
      group.items.push({
        stageName: group.stageName,
        name: (item && item.name) || "",
        unit: resolveUnit(item),
        num: item && item.num != null ? item.num : 0,
        price: item && item.price != null ? item.price : 0,
        totalPrice: item && item.totalPrice != null ? item.totalPrice : 0,
        remark: "",
        costGrouping: stage && stage.costGrouping,
        merchantFeeCategory: item && item.merchantFeeCategory,
        waterproofAreaRole: item && item.waterproofAreaRole
      });
      group.subtotalCents += amountCents;
    });
  });

  group.items = mergeMerchantItems(group.items, group.stageName);
  const groups = group.items.length > 0 ? [{
    ...group,
    subtotal: group.subtotalCents / 100
  }] : [];
  const totalCents = group.subtotalCents;
  return { groups, total: totalCents / 100 };
};

export const resolveLastEngineeringSubmitTime = costData => {
  let latest = null;
  (Array.isArray(costData) ? costData : []).forEach(stage => {
    if (stage && stage.status === "CANCELLED") return;
    const submitTime = Number(stage && stage.submitTime);
    if (Number.isFinite(submitTime) && submitTime > 0 && (latest === null || submitTime > latest)) {
      latest = submitTime;
    }
  });
  return latest;
};

export const buildWaterproofMerchantFeePrintHtml = ({
  declaration,
  groups,
  total,
  voucher,
  printCount,
  trackPrintCount
}) => {
  const row = declaration || {};
  const voucherAmount = toCents(voucher) / 100;
  const receivedAmount = (toCents(total) - toCents(voucherAmount)) / 100;
  let sequence = 1;
  const groupSections = (groups || []).map(group => {
    const itemRows = group.items.map((item, index) => `
      <tr>
        <td>${sequence++}</td>
        ${index === 0 ? `<td class="stage-cell" rowspan="${group.items.length}">${escapeHtml(item.stageName)}</td>` : ""}
        <td>${escapeHtml(item.name)}</td>
        <td>${escapeHtml(item.unit)}</td>
        <td>${escapeHtml(item.num)}</td>
        <td>${formatMoney(item.price)}</td>
        <td>${formatMoney(item.totalPrice)}</td>
        <td>${escapeHtml(item.remark)}</td>
      </tr>`).join("");
    return `
      <section class="fee-group">
        <h2>${escapeHtml(group.name)}</h2>
        <table>
          <thead>
            <tr>
              <th>序号</th><th>阶段</th><th>项目</th><th>单位</th>
              <th>数量</th><th>单价</th><th>金额</th><th>备注</th>
            </tr>
          </thead>
          <tbody>
            ${itemRows}
            <tr class="subtotal-row">
              <td colspan="6">${escapeHtml(group.name)}小计</td>
              <td>${formatMoney(group.subtotal)}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </section>`;
  }).join("");

  const voucherSummary = voucherAmount > 0
    ? `<p>摘要：代金券 ${formatMoney(voucherAmount)} 元，实收金额 ${formatMoney(receivedAmount)} 元</p>`
    : "";
  const countSummary = trackPrintCount
    ? `<p>打印次数：${Number(printCount || 0) + 1}次</p>`
    : "";

  return `<!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <title>销售出库单</title>
        <style>
          * { box-sizing: border-box; }
          body { margin: 0; color: #000; background: #fff; font-family: "SimHei", "黑体", sans-serif; font-size: 12pt; }
          .print-container { width: 100%; max-width: 210mm; margin: 0 auto; padding: 12mm; }
          h1 { margin: 0 0 5mm; text-align: center; font-size: 16pt; }
          .basic-info { margin-bottom: 5mm; }
          .info-row { display: flex; margin-bottom: 3mm; line-height: 1.4; }
          .info-item { flex: 1; padding-right: 5mm; }
          .info-label { font-weight: bold; }
          .fee-group { margin-bottom: 5mm; page-break-inside: avoid; }
          .fee-group h2 { margin: 0 0 2mm; text-align: left; font-size: 13pt; }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #000; padding: 2mm 1.5mm; text-align: center; font-size: 11pt; line-height: 1.3; }
          th { font-weight: bold; }
          .stage-cell { vertical-align: middle; font-weight: bold; }
          .subtotal-row, .total-row { font-weight: bold; }
          .grand-total { margin-top: 2mm; }
          .summary { margin-top: 4mm; line-height: 1.8; }
          .footer { margin-top: 4mm; text-align: right; line-height: 1.6; }
          @media print {
            @page { size: A4; margin: 2mm; }
            .print-container { padding: 10mm; }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <h1>销售出库单</h1>
          <div class="basic-info">
            <div class="info-row">
              <div class="info-item"><span class="info-label">客户简称：</span>${escapeHtml(row.abbreviation || "无")}</div>
              <div class="info-item"><span class="info-label">报单编号：</span>${escapeHtml(row.number || "无")}</div>
            </div>
            <div class="info-row">
              <div class="info-item"><span class="info-label">客户全称：</span>${escapeHtml(row.shopName || "无")}</div>
              <div class="info-item"><span class="info-label">户型：</span>${escapeHtml(row.houseType || "无")}</div>
            </div>
            <div class="info-row">
              <div class="info-item"><span class="info-label">业务员：</span>${escapeHtml(row.introducer || "无")}</div>
              <div class="info-item"><span class="info-label">装饰公司：</span>${escapeHtml(row.paymentTarget || "无")}</div>
            </div>
            <div class="info-row">
              <div class="info-item"><span class="info-label">报单时间：</span>${formatDateTime(row.createTime)}</div>
              <div class="info-item"><span class="info-label">交付时间：</span>${formatDateTime(row.lastEngineeringSubmitTime)}</div>
            </div>
            <div class="info-row">
              <div class="info-item"><span class="info-label">交付地址：</span>${escapeHtml(row.customAddress || "无")}</div>
            </div>
          </div>
          ${groupSections}
          <table class="grand-total">
            <tbody>
              <tr class="total-row">
                <td>费用合计：${escapeHtml(numberToChineseMoney(total))}</td>
                <td style="width: 28%;">${formatMoney(total)}</td>
              </tr>
            </tbody>
          </table>
          <div class="summary">${voucherSummary}</div>
          <div class="footer">
            <p>打印时间：${formatDateTime(Date.now())}</p>
            ${countSummary}
          </div>
        </div>
      </body>
    </html>`;
};
